<template>
  <div class="pkcs8upload">
    <form method="POST" enctype="multipart/form-data" id="form" @submit.prevent="cargarKey" >
      <div class='forma'>
        <v-row align='center' dense>
          <v-col cols='12' sm='4' md='3' lg='2'>Certificado (.cer)</v-col>
          <v-col cols='12' sm='8' md='9' lg='10'>
            <v-file-input type="file" id="cer" accept=".cer" v-model="certInput"></v-file-input>
          </v-col>
        </v-row>
        <v-row align='center' dense>
          <v-col cols='12' sm='4' md='3' lg='2'>Llave privada (.key)</v-col>
          <v-col cols='12' sm='8' md='9' lg='10'>
            <v-file-input type="file" id="key" accept=".key" name="key" v-model="keyInput"></v-file-input>
          </v-col>
        </v-row>
        <v-row align='center' dense>
          <v-col cols='12' sm='4' md='3' lg='2'>Contraseña</v-col>
          <v-col cols='12' sm='8' md='9' lg='10'>
            <v-text-field
              v-model="password"
              id="password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required]"
              :type="show1 ? 'text' : 'password'"
              name="password"
              label="Introduzca su contraseña"
              @click:append="show1 = !show1"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col><v-switch
              v-show="hasUsername"
              v-model="saveKey"
              :label="`Llave: ${setKeySelection(saveKey)}`"
            ></v-switch>
          </v-col>
        </v-row>
        <v-row><v-col></v-col></v-row>
        <v-row>
          <v-btn color="primary" class="button" value="cargar" type="submit" name="cargar" id="submit" :disabled="!isReady">Cargar</v-btn>
          <v-btn color="primary" class="button" @click="backFirmas" value="cancelar" type="submit">Cancelar</v-btn>
        </v-row>
      </div>
    </form>
  </div>
</template>

<script>
import { cargarFile } from '@/utils/readFile.js';
export default {
  name: 'PKCS8upload',
  data () {
    return {
      password: '',
      saveKey: false,
      show1: false,
      rules: {
        required: value => !!value || 'Required.'
      },
      certInput: {size: 0},
      keyInput: {size: 0},
    }
  },
  computed: {
    isReady() {
      if (this.certInput.size > 0 && this.keyInput.size > 0 && this.password.length > 0) return true;
      return false;
    },
    hasUsername() {
      const username = this.$store.getters.getUser.username;
      if (typeof username === 'string' && username.length > 0) return true;
      return false;
    },
  },
  methods: {
    setKeySelection(save){
      if(save){
        return "Guardar para después";
      }else{
        return "Usar sólo ésta vez";
      }
    },
    backFirmas(){
      this.$emit('cancelEvent')
    },
    async cargarKey (event) {
      console.debug('cargarKey event: %o', event)
      /*
      if (event.explicitOriginalTarget.innerHTML === 'Cancelar') {
        this.$emit('cancelEvent')
        return
      }*/
      // let res = confirm( "Se cargara la e.firma" )
      // alert (res)
      let saveKey = this.saveKey;
      console.groupCollapsed('cer')
      let cerA = await cargarFile(cer.files[0])
      console.debug('cer: %o', cerA)
      console.groupEnd()
      console.groupCollapsed('key')
      let keyA = await cargarFile(key.files[0])
      console.debug('key: %o', keyA)
      console.groupEnd()
      this.$emit('PKCS8UploadEvent', { 'password': password.value, 'cer': cerA, 'key': keyA, 'save': saveKey })
    }
  },
  watch: {
    certInput() {
      if (this.certInput === undefined) {
        this.certInput = {size: 0}
      }
    },
    keyInput() {
      if (this.keyInput === undefined) {
        this.keyInput = {size: 0}
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.pkcs8upload { 
  float: center;
  border: none; }
.button{
  margin: 5px;
}
.forma{
  margin: 5% 10% 5% 15%;
  text-align:left;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
table td {  }
/* table td { border:1px solid black; } */
/* form { border:1px solid red; } */
</style>
